import React, { useEffect, useState } from "react";
import { motion, AnimatePresence, transform } from "framer-motion";
import M1 from "assets/images/svg/am/AC.svg";
import M2 from "assets/images/svg/am/cardio-machine.svg";
import M3 from "assets/images/svg/am/Fitness-studio.svg";
import M4 from "assets/images/svg/am/free-we.svg";
import M5 from "assets/images/svg/am/functional-training.svg";
import M6 from "assets/images/svg/am/lane-swimming.svg";
import M7 from "assets/images/svg/am/locker.svg";
import M8 from "assets/images/svg/am/mat-area.svg";
import M9 from "assets/images/svg/am/Olympic-weights.svg";
import M10 from "assets/images/svg/am/Personal-training.svg";
import M11 from "assets/images/svg/am/Pilates.svg";
import M12 from "assets/images/svg/am/power-plates.svg";
import M13 from "assets/images/svg/am/punching-bag.svg";
import M14 from "assets/images/svg/am/resistance-machines.svg";
import M15 from "assets/images/svg/am/sauna.svg";
import M16 from "assets/images/svg/am/shower.svg";
import M17 from "assets/images/svg/am/spa-facilities.svg";
import M18 from "assets/images/svg/am/steam-room.svg";
import M19 from "assets/images/svg/am/towels.svg";
import M20 from "assets/images/svg/am/wifi-02.svg";
import M21 from "assets/images/svg/am/yoga-02.svg";
import FacilitiesImg from "assets/images/facilities.jpg";
import Lunges from "components/animation/hero/Lunges";
import SwimmingPool from "assets/images/svg/swimming-pool.svg";
const contentData = [
  {
    image: M1,
    name: "AC",
  },
  {
    image: M2,
    name: "Cardio Machine",
  },
  {
    image: M3,
    name: "Fitness Studio",
  },
  {
    image: M4,
    name: "Free Weights",
  },
  {
    image: M5,
    name: "Functional Training",
  },
  {
    image: M6,
    name: "Lane Swimming",
  },
  {
    image: M7,
    name: "Locker",
  },
  {
    image: M8,
    name: "Mat Area",
  },
  {
    image: M9,
    name: "Olympic Weights",
  },
  {
    image: M10,
    name: "Personal Training",
  },
  {
    image: M11,
    name: "Pilates",
  },
  {
    image: M12,
    name: "Power Plates",
  },
  {
    image: M13,
    name: "Punching Bag",
  },
  {
    image: M14,
    name: "Resistance Machines",
  },
  {
    image: M15,
    name: "Sauna",
  },
  {
    image: M16,
    name: "Shower",
  },
  {
    image: M17,
    name: "Spa Facilities",
  },
  {
    image: M18,
    name: "Steam Room",
  },
  {
    image: M19,
    name: "Towels",
  },
  {
    image: M20,
    name: "Wifi",
  },
  {
    image: M21,
    name: "Yoga",
  },
];
function Facilities() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [hovered, setHovered] = useState(false); // State to track hover status

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % contentData.length);
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + contentData.length) % contentData.length
    );
  };

  useEffect(() => {
    if (!hovered) {
      // Only auto-slide when not hovered
      const timeout = setTimeout(() => {
        nextSlide();
      }, 3000); // Change slide every 3 seconds

      return () => clearTimeout(timeout); // Cleanup timeout on unmount or slide change
    }
  }, [currentIndex, hovered]); // Re-run whenever `currentIndex` or `hovered` changes

  return (
    <div className="container-fluid facilities-bg position-relative z-index-1  hw-100 d-flex align-items-center">
      <img className="background-svg py-5" src={FacilitiesImg} alt="" />
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 facilities-left-col">
            <div className="facilities-you-need-content text-md-start text-center mt-lg-4">
              <h2 className="fs-80  l-h-0-9 hc fw-700 l-height mt-lg-5">
                FACILITIES
              </h2>
              <p className="fs-64 l-h-0-9 custom-color-blue fw-300">YOU NEED</p>
            </div>
          </div>
        </div>
        <div className="row  flex-sm-row flex-column-reverse">
          <div className="col-lg-6 col-md-6 col-sm-6 facilities-col-2 position-relative z-index-1 ">
            <div className="facilities-svg mt-4 text-md-start text-center">
              <Lunges />
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6 facilities-col-2 py-4 position-relative z-index-1 text-center d-flex align-items-center justify-content-center">
            <svg
              className="background-svg-magnifier"
              viewBox="0 0 637 637"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M491.063 491.063L632.25 632.25M569.5 287.125C569.5 131.174 443.076 4.75 287.125 4.75C131.174 4.75 4.75 131.174 4.75 287.125C4.75 443.076 131.174 569.5 287.125 569.5C443.076 569.5 569.5 443.076 569.5 287.125Z"
                stroke="#3BABA6"
                strokeWidth="8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
              style={{
                position: "relative",
                width: "300px",
                height: "300px",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <AnimatePresence mode="wait">
                <motion.div
                  key={currentIndex}
                  initial={{ x: 300, opacity: 0, scale: 0.2 }}
                  animate={{ x: 0, opacity: 1, scale: 1 }}
                  exit={{ x: -300, opacity: 0, scale: 0.2 }}
                  transition={{ duration: 0.8 }}
                  style={{
                    textAlign: "center",
                    position: "absolute",
                    width: "100%",
                  }}
                >
                  <motion.img
                    src={contentData[currentIndex].image}
                    alt={`Slide ${currentIndex + 1}`}
                    style={{
                      width: "60%",
                      height: "60%",
                      objectFit: "contain",
                      marginBottom: "1rem",
                    }}
                  />
                  <motion.p className="fs-32 l-h-0-9 fw-300 text-white w-75 mx-auto">
                    {contentData[currentIndex].name}
                  </motion.p>
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Facilities;
